import * as z from 'zod'

import { HOUSEHOLD_AT_CONSTANTS, HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as validators from '@flows/configs/shared/validators'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const claimsOptionsFromSchema = schemaUtils.getEnumValuesFromPipelineSchema(
  BaseSchema_HouseholdV1GetsafeAt.shape.number_of_previous_claims.unwrap()
)

const household_at_number_of_previous_claims = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('number_of_previous_claims')]:
        validators.createPreprocessedEnumNumberSchema(z.enum([...claimsOptionsFromSchema, '2'])),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.number_of_previous_claims.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('number_of_previous_claims'),
        options: HOUSEHOLD_AT_CONSTANTS.claimsOptions,
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('number_of_previous_claims'),
      valueToStepName: {
        0: HOUSEHOLD_STEPS.household_at_contact_details,
        1: HOUSEHOLD_STEPS.household_at_contact_details,
        2: FAILURE_STEP_NAME,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default household_at_number_of_previous_claims
